import React, { useEffect } from 'react'
import { Col, Container, Form, Row } from 'react-bootstrap'
import Section from '../../Utilitis/Section'
import SingalHeader from '../../Utilitis/SingalHeader'
import Tag from '../../Utilitis/Tag'
import CourseComment from '../SingleCourse/Component.js/CourseComment'
import { OtherInfo, BlogInfo, WriteInfo, Item, SearchBtn, BlogTags } from './Style'
import ScrollAnimation from 'react-animate-on-scroll';
import { motion } from 'framer-motion'


export default function SingalBlog() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <motion.div
                initial={{ x: "100%" }}
                animate={{ x: 0 }}
                exit={{ x: "-100%" }}
                transition={{ duration: 0.3 }}
            >
                <SingalHeader title="Singal Blog" />
                <Section bg="#f3f7f9">
                    <Container>
                        <Row>
                            <Col lg={8} md={12} sm={12} xs={12}>
                                <ScrollAnimation animateIn="animate__fadeInLeft">
                                    <BlogInfo>
                                        <img src={"/images/bg4.jpg"} />
                                        <h6>Best Education Course</h6>
                                        <WriteInfo>
                                            <div>
                                                <i className="fas fa-user-edit"></i>
                                                <span>Alan Jhone</span>
                                            </div>
                                            <div>
                                                <i className="fas fa-calendar-alt"></i>
                                                <span>20 sep 2021</span>
                                            </div>
                                            <div>
                                                <i className="fas fa-tag"></i>
                                                <span>Web ,React</span>
                                            </div>
                                        </WriteInfo>
                                        <p>
                                            Claritas est etiam processus dynamicus,
                                            qui sequitur mutationem consuetudium lectorum. Mirum est
                                            notare quam littera gothica, quam nunc putamus parum claram,
                                            anteposuerit litterarum formas humanitatis per seacula quarta decima
                                            et quinta decima. Eodem modo typi, qui nunc nobis videntur parum clari,
                                            fiant sollemnes in futurum.
                                        </p>
                                        <p>
                                            Claritas est etiam processus dynamicus,
                                            qui sequitur mutationem consuetudium lectorum. Mirum est
                                            notare quam littera gothica, quam nunc putamus parum claram,
                                            anteposuerit litterarum formas humanitatis per seacula quarta decima
                                            et quinta decima. Eodem modo typi, qui nunc nobis videntur parum clari,
                                            fiant sollemnes in futurum.
                                        </p>
                                        <p>
                                            Claritas est etiam processus dynamicus,
                                            qui sequitur mutationem consuetudium lectorum. Mirum est
                                            notare quam littera gothica, quam nunc putamus parum claram,
                                            anteposuerit litterarum formas humanitatis per seacula quarta decima
                                            et quinta decima. Eodem modo typi, qui nunc nobis videntur parum clari,
                                            fiant sollemnes in futurum.
                                        </p>
                                    </BlogInfo>
                                    <CourseComment />
                                </ScrollAnimation>
                            </Col>
                            <Col lg={4} md={12} sm={12} xs={12}>
                                <ScrollAnimation animateIn="animate__fadeInRight">
                                    <OtherInfo>
                                        <Item>
                                            <h6>Search</h6>
                                            <Form>
                                                <Form.Control type="text" placeholder="Serach ..."></Form.Control>
                                                <SearchBtn type="submit" >
                                                    <i className="fas fa-search"></i>
                                                </SearchBtn>
                                            </Form>
                                        </Item>
                                    </OtherInfo>
                                    <OtherInfo>
                                        <Item>
                                            <h6>Categorie</h6>
                                        </Item>
                                    </OtherInfo>
                                    <OtherInfo>
                                        <Item>
                                            <h6>Tags</h6>
                                            <BlogTags>
                                                <Tag text="react" />
                                                <Tag text="react" />
                                                <Tag text="react" />
                                                <Tag text="react" />
                                                <Tag text="react" />
                                                <Tag text="react" />
                                            </BlogTags>
                                        </Item>
                                    </OtherInfo>
                                </ScrollAnimation>
                            </Col>
                        </Row>
                    </Container>
                </Section>
            </motion.div>
        </>
    )
}
